module.exports = __webpack_public_path__ + "ge.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/ge.svg
// module id = 814
// module chunks = 0